import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EnglishOnlyRoute from "./components/layout/EnglishOnlyRoute";

const DeferredToaster = lazy(async () => {
  const module = await import("react-hot-toast");
  return { default: module.Toaster };
});
const AppLayout = lazy(() => import("./components/layout/AppLayout"));
const Login = lazy(() => import("./pages/Login/Login"));
const LegalPage = lazy(() => import("./pages/Legal/LegalPage"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const Splash = lazy(() => import("./components/Splash/Splash"));
const Home = lazy(() => import("./pages/Home/Home"));
const Profile = lazy(() => import("./pages/Profile/Profile"));
const Payments = lazy(() => import("./pages/Payments/Payments"));
const Performance = lazy(() => import("./pages/Performance/Performance"));
const Attendance = lazy(() => import("./pages/Attendance/Attendance"));
// Rating page disabled — not yet approved
// const Rating = lazy(() => import("./pages/Rating/Rating"));
const Rewards = lazy(() => import("./pages/Rewards/Rewards"));
const Exams = lazy(() => import("./pages/Exams/Exams"));
const Cashier = lazy(() => import("./pages/Cashier/Cashier"));
const Streak = lazy(() => import("./pages/Streak/Streak"));
const Speaking = lazy(() => import("./pages/Speaking/Speaking"));
const Notifications = lazy(() => import("./pages/Notifications/Notifications"));
const Audios = lazy(() => import("./pages/Audios/Audios"));
const Calendar = lazy(() => import("./pages/Calendar/Calendar"));

function App() {
  return (
    <>
      <Suspense fallback={null}>
        <DeferredToaster />
      </Suspense>
      <Routes>
        <Route
          index
          element={
            <Suspense>
              <Splash />
            </Suspense>
          }
        />
        <Route
          path="login"
          element={
            <Suspense>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="privacy"
          element={
            <Suspense>
              <LegalPage type="privacy" />
            </Suspense>
          }
        />
        <Route
          path="terms"
          element={
            <Suspense>
              <LegalPage type="terms" />
            </Suspense>
          }
        />
        <Route
          element={
            <Suspense>
              <AppLayout />
            </Suspense>
          }
        >
          <Route
            path="home"
            element={
              <Suspense>
                <Home />
              </Suspense>
            }
          />
          <Route
            path="dashboard"
            element={
              <Suspense>
                <Home />
              </Suspense>
            }
          />
          <Route
            path="profile"
            element={
              <Suspense>
                <Profile />
              </Suspense>
            }
          />
          <Route
            path="profile/setup"
            element={<Navigate to="/profile" replace />}
          />
          <Route
            path="calendar"
            element={
              <Suspense>
                <Calendar />
              </Suspense>
            }
          />
          <Route
            path="notifications"
            element={
              <Suspense>
                <Notifications />
              </Suspense>
            }
          />
          <Route
            path="inbox"
            element={<Navigate to="/notifications" replace />}
          />
          <Route
            path="payments"
            element={
              <Suspense>
                <Payments />
              </Suspense>
            }
          />
          <Route
            path="documents"
            element={<Navigate to="/payments" replace />}
          />
          <Route
            path="performance"
            element={
              <Suspense>
                <Performance />
              </Suspense>
            }
          />
          <Route
            path="attendance"
            element={
              <Suspense>
                <Attendance />
              </Suspense>
            }
          />
          {/* Rating route disabled — not yet approved
          <Route
            path="rating"
            element={
              <Suspense>
                <Rating />
              </Suspense>
            }
          />
          */}
          <Route
            path="rewards"
            element={
              <Suspense>
                <Rewards />
              </Suspense>
            }
          />
          <Route
            path="assignments"
            element={
              <Suspense>
                <Rewards />
              </Suspense>
            }
          />
          <Route
            path="audios"
            element={
              <EnglishOnlyRoute>
                <Suspense>
                  <Audios />
                </Suspense>
              </EnglishOnlyRoute>
            }
          />
          <Route
            path="exams"
            element={
              <Suspense>
                <Exams />
              </Suspense>
            }
          />
          <Route
            path="cashier"
            element={
              <Suspense>
                <Cashier />
              </Suspense>
            }
          />
          <Route
            path="streak"
            element={
              <EnglishOnlyRoute>
                <Suspense>
                  <Streak />
                </Suspense>
              </EnglishOnlyRoute>
            }
          />
          <Route
            path="speaking"
            element={
              <EnglishOnlyRoute>
                <Suspense>
                  <Speaking />
                </Suspense>
              </EnglishOnlyRoute>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Suspense>
              <NotFound />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}

export default App;
